import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EAlert } from 'shared/types/alert';

type TAlertState = {
  isVisible: boolean;
  message?: string;
  type?: EAlert;
};

const initialState: TAlertState = {
  isVisible: false,
};

type TAlertPayload = {
  type?: EAlert;
  message?: string;
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert(state, action: PayloadAction<TAlertPayload>) {
      state.isVisible = true;
      if (action) {
        state.message = action.payload.message;
        state.type = action.payload.type;
      }
    },
    hideAlert() {
      return initialState;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export const alertReducer = alertSlice.reducer;
